import $ from 'jquery';

$.ajax({
  url: AJAX_URL, 
  data: {'action': 'ajax_user_online'}, 
  cache: false,
  success: function(response) {
    $('.js-user-online-now').text(response.now);
    $('.js-user-online-total').text(response.total);
    $('.js-user-online-month').text(response.month);
    $('.js-user-online-today').text(response.today);
  }
});
